import {
    UNIVERSAL_RECORD_TYPES,
    UniversalRecordIdentifierError
} from "@/services/universalRecordIdentifier";

const INTAKE_ROUTE_NAMES = Object.freeze({
    [UNIVERSAL_RECORD_TYPES.Meat]: "MeatView",
    [UNIVERSAL_RECORD_TYPES.Ingredient]: "IngredientView",
    [UNIVERSAL_RECORD_TYPES.Packaging]: "PackagingItemView",
    [UNIVERSAL_RECORD_TYPES.Product]: "ProductView"
});

export const UNIVERSAL_INTAKE_RECORD_TYPES = Object.freeze(Object.keys(INTAKE_ROUTE_NAMES));

export function universalRecordRoute(identifier) {
    const routeName = INTAKE_ROUTE_NAMES[identifier?.recordType];
    if (!routeName) {
        throw new UniversalRecordIdentifierError(
            "unsupported_record_type",
            `Forkto record type ${identifier?.recordType || "(missing)"} cannot be opened here.`,
            { recordType: identifier?.recordType }
        );
    }
    return {
        name: routeName,
        params: { id: identifier.recordId }
    };
}

export function universalIntakeResolvers(api) {
    return {
        [UNIVERSAL_RECORD_TYPES.Meat]: (id) => api.Meat.GetByID(id),
        [UNIVERSAL_RECORD_TYPES.Ingredient]: (id) => api.Ingredient.GetByID(id),
        [UNIVERSAL_RECORD_TYPES.Packaging]: (id) => api.Packaging.GetByID(id),
        [UNIVERSAL_RECORD_TYPES.Product]: (id) => api.Product.GetByID(id)
    };
}
